import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=a2f944fc"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f944fc')) {
      api.createRecord('a2f944fc', component.options)
    } else {
      api.reload('a2f944fc', component.options)
    }
    module.hot.accept("./PaymentInfo.vue?vue&type=template&id=a2f944fc", function () {
      api.rerender('a2f944fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/company/PaymentInfo.vue"
export default component.exports